import packageInfo from '../../../versions.json';

export const environment = {
  production: true,
  version: packageInfo['rio-version'],
};
